import React from 'react'
import Logo from '../../assets/images/Logo.svg'

const Footer = () => {
  return (
    <footer>
          <img src={Logo} alt="Kasa" />
          <p>&copy; 2020 Kasa. All rights reserved</p>
    </footer>
  )
}

export default Footer